import { TOKEN_NOT_PROVIDED, TOKEN_INVALID } from './types/ERROR_MESSAGES'
import cookieHandler from './cookieHandler'

export default (errorMessage) => {
  if (errorMessage === TOKEN_NOT_PROVIDED || errorMessage === TOKEN_INVALID) {
    cookieHandler.remove('token')
    window.location.href = process.env.VUE_APP_BASE_URL + '/#/login'
  }
}
